module.exports = function (productGroupService, offerGroupService) {
    return {
        restrict: 'E',
        scope: {
            groupType: '=',
        },
        link(scope) {
            const groupService = scope.groupType === 'OfferGroup' ? offerGroupService : productGroupService;

            scope.isGroupLoading = function () {
                return groupService.selectedGroup === undefined;
            };

            scope.isCountLoading = function () {
                return groupService.selectedGroupTotalCount === undefined;
            };

            scope.productGroupName = function () {
                return groupService.selectedGroup.Description;
            };

            scope.productsCount = function () {
                return groupService.selectedGroupTotalCount;
            };
        },
        template: require('./productgroup.directive.html').trim(),
    };
};



// WEBPACK FOOTER //
// ./src/shop/productgroups/productgroup.directive.js